export const capitalizeFirstLetter = (str) => {
  if (typeof str !== 'string' || str.trim().length === 0) return str;
  return str.trim().charAt(0).toUpperCase() + str.trim().slice(1);
}
